/**
 * Height of the fixed final-rewards footer (`h-[156px]` in
 * fixed-final-rewards.tsx and the 156-tall viewBox in
 * bottom-final-reward-frame.tsx — Tailwind/SVG literals that cannot import
 * this value).
 */
export const FINAL_REWARDS_FOOTER_HEIGHT_PX = 156

/**
 * rootMargin for the jump point pill IntersectionObservers. While the
 * footer is showing it obscures the bottom of the viewport, so a pill
 * behind it is not visible; once the page bottom scrolls into view the
 * footer hides and the full viewport counts (design Example C: both pills
 * visible → no anchor).
 */
export function getJumpPillRootMargin(isFooterShowing: boolean): string {
  return isFooterShowing
    ? `0px 0px -${FINAL_REWARDS_FOOTER_HEIGHT_PX}px 0px`
    : '0px'
}
